import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Badge, IconButton } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { useRecoilValue } from 'recoil';
import { OfferSummary } from '../../interfaces/Offer/OfferSummary';
import { getValidOffers } from '../../api/Offer';
import { useThemeColor } from '../../hooks/useThemeColor';
import { OffersDialog } from '../Offer/OffersDialog';
import { settingsAtom } from '../../atoms/Settings';

export const OffersButton = () => {
  const { primary, secondary } = useThemeColor();

  const settings = useRecoilValue(settingsAtom);

  const [offers, setOffers] = useState<OfferSummary[]>([]);
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    getValidOffers()
      .then(setOffers)
      .catch((err) => toast.error(err.message));
  }, []);

  if (!offers.length) return null;

  return (
    <>
      <IconButton onClick={() => setShowDialog(true)}>
        <Badge
          badgeContent={offers.length.toString()}
          sx={{
            '& .MuiBadge-badge': {
              color: secondary,
              backgroundColor: primary,
              ...settings.settingsV2?.appHeaderSettings?.iconBadgeStyle,
            },
          }}
          overlap='circular'
          style={{ transform: 'translate(25px, -15px)' }}
        />

        <LocalOfferIcon
          sx={{
            ...settings.settingsV2?.appHeaderSettings?.iconStyle,
          }}
        />
      </IconButton>

      <OffersDialog
        offers={offers}
        open={showDialog}
        onClose={() => setShowDialog(false)}
      />
    </>
  );
};
